import * as React from 'react';
import MultiSelectListBox from 'react-multiselect-listbox';

import { RCUtils } from './../../RCUtils';
import { PopupWindow } from './PopupWindow';
import * as RCNGWindow from '../sharedcomponents/ConfirmationWindow';
import $ from 'jquery';
import forEach from 'lodash/forEach';
import { GridReeferStatusToolBar } from '../sharedcomponents/GridReeferStatusToolBar';
import { GridReeferHistoryToolBar } from '../sharedcomponents/GridReeferHistoryToolBar';
import { GridToolBarExcel } from './../sharedcomponents/GridToolBarExcel';
import { GridGensetStatusToolBar } from '../sharedcomponents/GridGensetStatusToolBar';
import { GridGensetHistoryToolBar } from '../sharedcomponents/GridGensetHistoryToolBar';
/* Start WI 27261*/
import { GensetHistoryGrid } from '../childcomponents/GensetHistoryGrid';
import { ReeferHistoryGrid } from '../childcomponents/ReeferHistoryGrid';
import { DryHistoryGrid } from '../childcomponents/DryHistoryGrid';
import { ChassisHistoryGrid } from '../childcomponents/ChassisHistoryGrid';
import { ReeferMapGrid } from '../childcomponents/ReeferMapGrid';
/* End WI 27261*/

var Config: any = require('../../Config.json');

var self;
var prefChanged: boolean = false;

export interface GridColumnPreference {
    selectedKeys: any;
    exportColumns: any;
    copyToHistory: boolean;
    saveRowGroups: boolean;
}

export class GridColumnPreferences extends React.Component<any, GridColumnPreference> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedKeys: [],
            exportColumns: [],
            copyToHistory: true,
            saveRowGroups: this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false
        };

        self = this;

        this.LoadDefaultGridColumns(this.props.functionId);
    }

    LoadDefaultGridColumns(functionId: any) {
        prefChanged = false;
        this.setState({ exportColumns: [], selectedKeys: [] });
        $('#globalLoader').show();
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetCustomerInterfaceExportColumns?FunctionId=' + functionId)
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                //this.setState({ exportColumns: data });
                this.BindSavedPreferenceData(functionId, data);
            });
    }

    componentDidMount() {
        var functionId = this.props.functionId;
        if (functionId == 41 || functionId == 46 || functionId == 48 || functionId == 61) { //WI 26721
            if ($("#divCopyToHistory").hasClass("d-none")) $('#divCopyToHistory').removeClass('d-none');
        }
        else {
            if (!$("#divCopyToHistory").hasClass("d-none")) $('#divCopyToHistory').addClass('d-none');
        }
        //if (functionId == 42 || functionId == 47 || functionId == 49 || functionId == 62 || functionId == 66) 
        //    document.getElementById("CopyToHistoryFooter").classList.remove("justify-content-between");
        //else 
        //    document.getElementById("CopyToHistoryFooter").classList.add("justify-content-between");
    }

    componentWillReceiveProps(nextprops: any) {
        this.setState({ copyToHistory: true });
        var functionId = nextprops.functionId;
        if (functionId != undefined && functionId != null && functionId != "") {
            if (functionId == 41 || functionId == 46 || functionId == 48 || functionId == 61) { //WI 26721
                if ($("#divCopyToHistory").hasClass("d-none")) $('#divCopyToHistory').removeClass('d-none');
            }
            else {
                if (!$("#divCopyToHistory").hasClass("d-none")) $('#divCopyToHistory').addClass('d-none');
            }
            this.LoadDefaultGridColumns(functionId);
        }
        //if (functionId == 42 || functionId == 47 || functionId == 49 || functionId == 62 || functionId == 66) 
        //    document.getElementById("CopyToHistoryFooter").classList.remove("justify-content-between");
        //else
        //    document.getElementById("CopyToHistoryFooter").classList.add("justify-content-between");
    }

    HideAllGridColumns() {
        //var defaultColumns = this.state.ExportColumns;
        //var allColumnsNames = defaultColumns.map(({ ColumnNm }) => ColumnNm);      
        var defaultColumns = self.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        //var allColumnsNames = defaultColumns.filter(x => x.getId());
        self.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
    }

    ShowHideGridColumns(columnNames: any) {
        self.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(columnNames, 0);
        //$.each(columnNames, function (index, value) {
        //    self.props.gridApiParams.gridOptionsWrapper.columnApi.moveColumn(value, index);
        //});
        self.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(columnNames, true);
    }

    static StatusGridPreferenceColumns(functionId: any, gridApiParams: any, gridPreferencesData: any, formName: any) {
        //$('#globalLoader').show();
        var dbPreID: any = 0; //RCNG 5353 Fix
        var url = Config.ApiBaseUrl + '/api/User/GetCustomerPreferenceData?FunctionId=' + functionId + '&DashboardPreferenceId=' + dbPreID;
        var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                var columnNames = null;
                if (gridPreferencesData != null && gridPreferencesData.length > 0) {
                    var preferenceData = JSON.parse(gridPreferencesData[0].SearchData);
                    if (preferenceData.SelectedColumnValues != "" && preferenceData.SelectedColumnValues != null) {
                        var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);

                        var userColumnNames = preferenceData.SelectedColumnValues;
                        if (data.CustomerPreference != null) {
                            var customerPreference = JSON.parse(data.CustomerPreference);
                            var customerSelectedColumns = customerPreference.SelectedColumnValues;
                            columnNames = userColumnNames.filter(value => -1 !== customerSelectedColumns.indexOf(value));
                        }
                        else {
                            if (data.DefaultCustomerPreference != null) {
                                var defaultCustomerPreference = JSON.parse(data.DefaultCustomerPreference);
                                var defaultCustomerColumns = defaultCustomerPreference.SelectedColumnValues;
                                //columnNames = preferenceData.SelectedColumnValues;
                                defaultCustomerColumns = defaultCustomerColumns.concat(data.DeviceSensors).concat(data.CustomerAttributes);//WI 26721
                                columnNames = userColumnNames.filter(value => -1 !== defaultCustomerColumns.indexOf(value));
                            }
                            else
                                columnNames = preferenceData.SelectedColumnValues;
                        }

                        

                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(columnNames, 0);
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(columnNames, true);
                        //var allColumnsNames = defaultColumns.map(function (v, i) { return v.colId });
                        //var customColumns = differenceWith(columnNames, allColumnsNames, isEqual);
                        //if (customColumns.length > 0) {
                        //    var selectedColumns = difference(columnNames, customColumns);
                        //    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(selectedColumns, 0);
                        //    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(selectedColumns, true);
                        //}
                        //else {
                        //    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(columnNames, 0);
                        //    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(columnNames, true);
                        //}
                    }
                    else if (preferenceData.SelectedRowGroups != null && preferenceData.SelectedRowGroups.length >= 0) {
                        //var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        //gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, true);
                        //gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnVisible('0', false);
                        var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                        if (data.CustomerPreference != null) {
                            var customerPreference = JSON.parse(data.CustomerPreference);
                            var customerSelectedColumns = customerPreference.SelectedColumnValues;
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(customerSelectedColumns, true);
                        }
                        else if (data.DefaultCustomerPreference != null) {
                            var defaultCustomerPreference = JSON.parse(data.DefaultCustomerPreference);
                            var defaultCustomerColumns = defaultCustomerPreference.SelectedColumnValues;
                            defaultCustomerColumns = defaultCustomerColumns.concat(data.DeviceSensors).concat(data.CustomerAttributes);//WI 26721
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultCustomerColumns, true);
                        }
                        else {
                            var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, true);
                        }
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnVisible('0', false);
                    }

                } else if (data.CustomerPreference != null) {
                    var preferenceData = JSON.parse(data.CustomerPreference);
                    if (preferenceData.SelectedColumnValues != "" && preferenceData.SelectedColumnValues != null) {
                        var userColumnNames = preferenceData.SelectedColumnValues;
                        columnNames = preferenceData.SelectedColumnValues;

                        var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);

                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(columnNames, 0);
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(columnNames, true);

                        //var allColumnsNames = defaultColumns.map(function (v, i) { return v.colId });
                        //var customColumns = differenceWith(columnNames, allColumnsNames, isEqual);
                        //if (customColumns.length > 0) {
                        //    var selectedColumns = difference(columnNames, customColumns);
                        //    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(selectedColumns, 0);
                        //    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(selectedColumns, true);
                        //}
                        //else {
                        //    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(columnNames, 0);
                        //    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(columnNames, true);
                        //}
                    }
                }
                else {
                    if (functionId == 66) {
                        var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        var reqColumns = defaultColumns.filter(x => x.colId != "TWState" && x.colId != "TWTime");

                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(reqColumns, 0);
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(reqColumns, true);
                    }
                    else {
                        //var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        //gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, true);  
                        if (data.DefaultCustomerPreference != null) {
                            var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                            var defaultCustomerPreference = JSON.parse(data.DefaultCustomerPreference);
                            var defaultCustomerColumns = defaultCustomerPreference.SelectedColumnValues;
                            defaultCustomerColumns = defaultCustomerColumns.concat(data.DeviceSensors).concat(data.CustomerAttributes);//WI 26721
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultCustomerColumns, true);
                        }
                        else {
                            var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, true);
                        }
                    }
                    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnVisible('0', false);
                }
                if (formName == "ReeferStatusGrid") {
                    setTimeout(() => {
                        GridReeferStatusToolBar.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions);
                    }, 500);
                }
                else if (formName == "GensetStatusGrid") {
                    setTimeout(() => {
                        GridGensetStatusToolBar.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions);
                    }, 500);
                }
                else if (formName == "ReeferGrid" || formName == "GensetStatus") {
                    setTimeout(() => {
                        GridToolBarExcel.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions);
                    }, 500);
                }
            });
    }

    static HistoryGridPreferenceColumns(functionId: any, gridApiParams: any, gridPreferencesData: any, formName: any) {
        //$('#globalLoader').show();
        var dbPreID: any = 0;
        var url = Config.ApiBaseUrl + '/api/User/GetCustomerPreferenceData?FunctionId=' + functionId + '&DashboardPreferenceId=' + dbPreID;;
        var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                var columnNames = null;
                if (gridPreferencesData != null && gridPreferencesData.length > 0) {
                    var preferenceData = JSON.parse(gridPreferencesData[0].SearchData);
                    if (preferenceData.SelectedColumnValues != "" && preferenceData.SelectedColumnValues != null) {
                        var userColumnNames = preferenceData.SelectedColumnValues;
                        if (data.CustomerPreference != null) {
                            var customerPreference = JSON.parse(data.CustomerPreference);
                            var customerSelectedColumns = customerPreference.SelectedColumnValues;
                            columnNames = userColumnNames.filter(value => -1 !== customerSelectedColumns.indexOf(value));
                        }
                        else {
                            var defaultCustomerPreference = JSON.parse(data.DefaultCustomerPreference);
                            var defaultCustomerColumns = defaultCustomerPreference.SelectedColumnValues;
                            //columnNames = preferenceData.SelectedColumnValues;
                            defaultCustomerColumns = defaultCustomerColumns.concat(data.DeviceSensors);
                            columnNames = userColumnNames.filter(value => -1 !== defaultCustomerColumns.indexOf(value));
                        }

                        var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        //var allColumnsNames = defaultColumns.filter(x => x.getId());
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(columnNames, 0);
                        //$.each(columnNames, function (index, value) {
                        //    gridApiParams.gridOptionsWrapper.columnApi.moveColumn(value, index);
                        //});
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(columnNames, true);
                        //$('#globalLoader').hide();
                    }
                    else {
                        var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                        if (data.CustomerPreference != null) {
                            var customerPreference = JSON.parse(data.CustomerPreference);
                            var customerSelectedColumns = customerPreference.SelectedColumnValues;
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(customerSelectedColumns, true);
                        }
                        else if (data.DefaultCustomerPreference != null) {
                            var defaultCustomerPreference = JSON.parse(data.DefaultCustomerPreference);
                            var defaultCustomerColumns = defaultCustomerPreference.SelectedColumnValues;
                            defaultCustomerColumns = defaultCustomerColumns.concat(data.DeviceSensors);
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultCustomerColumns, true);
                        }
                        else {
                            var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, true);
                        }
                    }

                }
                else if (data.CustomerPreference != null) {
                    var preferenceData = JSON.parse(data.CustomerPreference);
                    if (preferenceData.SelectedColumnValues != "" && preferenceData.SelectedColumnValues != null) {

                        columnNames = preferenceData.SelectedColumnValues;
                        var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        //var allColumnsNames = defaultColumns.filter(x => x.getId());
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(columnNames, 0);
                        //$.each(columnNames, function (index, value) {
                        //    gridApiParams.gridOptionsWrapper.columnApi.moveColumn(value, index);
                        //});
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(columnNames, true);
                        //$('#globalLoader').hide();
                    }
                }
                else {
                    //var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                    //gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, true);
                    ////$('#globalLoader').hide();

                    var defaultCustomerPreference = JSON.parse(data.DefaultCustomerPreference);
                    var defaultCustomerColumns = defaultCustomerPreference.SelectedColumnValues;
                    defaultCustomerColumns = defaultCustomerColumns.concat(data.DeviceSensors);
                    var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);

                    /*var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();*/
                    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultCustomerColumns, true);

                    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnVisible('0', false);
                }

                if (formName == "ReeferHistoryGrid") {
                    setTimeout(() => {
                        GridReeferHistoryToolBar.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions);
                    }, 200);
                }
                else if (formName == "GensetHistoryGrid") {
                    setTimeout(() => {
                        GridGensetHistoryToolBar.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions);
                    }, 200);
                }

                else if (formName == "ReeferHistory" || formName == "GensetHistory") {
                    setTimeout(() => {
                        GridToolBarExcel.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions);
                    }, 200);
                }
            });
    }

    BindSavedPreferenceData(functionId: any, exportCols: any[]) {
        $('#globalLoader').show();
        var dashboardPreferenceId: any = this.props.dashboardPreferenceId;
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetDashboardWidgetsSearches?dashboardPreferenceId='+dashboardPreferenceId );
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                    if(data != null && data.length > 0)
                    {
                        var widgetPreferenceData: any = data;
                        var widgetId: any = this.props.widgetId;
                        var gridPreferences: any = widgetPreferenceData.filter(x=>x.DashboardWidgetId == widgetId);
                        if(gridPreferences != null && gridPreferences.length>0){
                        var preferenceData = JSON.parse(gridPreferences[0].SearchData);
                        if (preferenceData.SelectedColumnIds != null && preferenceData.SelectedColumnIds != undefined) {
                                var userSelectedKeys = preferenceData.SelectedColumnIds;
                                var defaultKeys = exportCols.map(item => item.InterfaceExportColumnId);
                                var selectedKeys:any = [];
                                forEach(userSelectedKeys, function (key) { //RCNG-2320
                                    if ($.inArray(key, defaultKeys) !== -1)
                                        selectedKeys.push(key);
                                });                      
                                //var selectedKeys = defaultKeys.filter(value => -1 !== userSelectedKeys.indexOf(value));//RCNG-1646

                                this.setState({ exportColumns: exportCols, selectedKeys: selectedKeys });
                            }
                            else {
                                var defaultKeys = exportCols.map(item => item.InterfaceExportColumnId);
                                this.setState({ exportColumns: exportCols, selectedKeys: defaultKeys });
                            }
                            $('#globalLoader').hide();
                        }
                        else {
                            //var defaultKeys = exportCols.filter(item => item.IsRequired == true).map(item => item.InterfaceExportColumnId);
                            if (functionId == 66) {
                                var defaultKeys = exportCols.filter(x => x.ColumnNm != "TWState" && x.ColumnNm != "TWTime").map(item => item.InterfaceExportColumnId);
                                this.setState({ exportColumns: exportCols, selectedKeys: defaultKeys });
                            }
                            else {
                                var defaultKeys = exportCols.map(item => item.InterfaceExportColumnId);
                                this.setState({ exportColumns: exportCols, selectedKeys: defaultKeys });
                            }

                            $('#globalLoader').hide();
                        }
                     }
                     else {
                            //var defaultKeys = exportCols.filter(item => item.IsRequired == true).map(item => item.InterfaceExportColumnId);
                            if (functionId == 66) {
                                var defaultKeys = exportCols.filter(x => x.ColumnNm != "TWState" && x.ColumnNm != "TWTime").map(item => item.InterfaceExportColumnId);
                                this.setState({ exportColumns: exportCols, selectedKeys: defaultKeys });
                            }
                            else {
                                var defaultKeys = exportCols.map(item => item.InterfaceExportColumnId);
                                this.setState({ exportColumns: exportCols, selectedKeys: defaultKeys });
                            }

                            $('#globalLoader').hide();
                    }
            });
        
    }

    ResetGridPreferences() {
        prefChanged = true;
        var data = this.state.exportColumns;
        //var defaultKeys = data.filter(item => item.IsRequired == true).map(item => item.InterfaceExportColumnId);
        var defaultKeys = data.map(item => item.InterfaceExportColumnId);
        this.setState({ exportColumns: data, selectedKeys: defaultKeys });
    }

    static ResetGridColumns(functionId: any, gridApiParams: any, formName: any) {
        $('#globalLoader').show();
        var exportColumns = null;
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetCustomerInterfaceExportColumns?FunctionId=' + functionId)
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {

                var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);

                var exportColumns = data;
                var selectedColumns = [];
                var selectedColumnsIds = [];
                var saveRowGroups = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0
                $.each(exportColumns, function (index, value) {
                    if (data.length > 0) {
                        var preferenceColumnNames = data[index].ColumnNm;
                        var preferenceColumnIds = data[index].InterfaceExportColumnId;
                        selectedColumnsIds.push(preferenceColumnIds);
                        selectedColumns.push(preferenceColumnNames);
                    }
                });

                var rowGroupedArray = [];
                if (saveRowGroups) {
                    if (gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns() != null && gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0) {
                        for (var i = 0; i < gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length; i++) {
                            // Validation 
                            if (selectedColumns.indexOf(gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns()[i].colId) !== -1) {
                                rowGroupedArray.push(gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns()[i].colId)
                            }
                        }
                    }
                }
                var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                var data1 = { SelectedColumnIds: selectedColumnsIds, SelectedColumnValues: selectedColumns, SelectedRowGroups: rowGroupedArray };
                //var data = { SelectedColumnIds: self.state.targetKeys, SelectedColumnValues: selectedColumns };
                var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(data1), CopyToHistory: false };//WI 26721
                var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response.json())
                    .then(data => {
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(selectedColumns, 0);
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(selectedColumns, true);

                        if (formName == "ReeferStatusGrid")
                            GridReeferStatusToolBar.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions);
                        else if (formName == "GensetStatusGrid")
                            GridGensetStatusToolBar.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions);
                        else if (formName == "ReeferGrid" || formName == "GensetStatus")
                            GridToolBarExcel.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions);
                        else if (formName == "ReeferHistoryGrid")
                            GridReeferHistoryToolBar.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions);
                        else if (formName == "GensetHistoryGrid")
                            GridGensetHistoryToolBar.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions);
                        else if (formName == "ReeferHistory" || formName == "GensetHistory")
                            GridToolBarExcel.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions);

                        $('#globalLoader').hide();
                    });
            });
    }

    SaveGridPreferences() {
        if (self.state.selectedKeys.length == 0)
            PopupWindow.showErrorMessage("Alert", "Please select at least one column to save grid preference.");
        else {
            var selectedCols = this.state.selectedKeys;
            if (selectedCols.length > 0 && prefChanged) {
                RCNGWindow.ConfirmWindow.showConfirmBox('Columns are modified. Do you want to save the changes?', this.onOKSubmit.bind(this), this.closeConfirmation.bind(this));
            }
            else if (selectedCols.length > 0 && !prefChanged) {
                RCNGWindow.ConfirmWindow.showConfirmBoxOK('Alert', 'Columns are not modified, please modify the grid preference columns.', this.closeConfirmation.bind(this));//RCNG-4191
            }
            else {
                this.onOKSubmit();
            }
        }
    }

    onOKSubmit() {
        if (self.state.selectedKeys.length > 0) {
            RCNGWindow.ConfirmWindow.close();
            $('#globalLoader').show();
            this.HideAllGridColumns();
            
            var defaultColumns = this.state.exportColumns;
            var selectedColumnIds = self.state.selectedKeys;
            var selectedColumns = [];
            //var rows = this.props.gridApiParams.gridOptionsWrapper.columnApi.getRowGroupColumns().slice();
            $.each(selectedColumnIds, function (index, value) {
                var data = defaultColumns.filter(x => x.InterfaceExportColumnId == parseInt(value));
                if (data.length > 0) {
                    var preferenceColumns = data[0].ColumnNm;
                    selectedColumns.push(preferenceColumns);
                }
            });
            var rowGroupedArray = [];
            if (this.state.saveRowGroups) {
                if (this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns() != null && this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0) {
                    for (var i = 0; i < this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length; i++) {
                        // Validation 
                        if (selectedColumns.indexOf(this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns()[i].colId) !== -1) {
                            rowGroupedArray.push(this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns()[i].colId)
                        }
                    }
                }
            }
            //var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
            var url = Config.ApiBaseUrl + '/api/User/SaveUserGridPreferences';
            var colsData = { SelectedColumnIds: self.state.selectedKeys, SelectedColumnValues: selectedColumns, SelectedRowGroups: rowGroupedArray };
            //var data = { SelectedColumnIds: self.state.targetKeys, SelectedColumnValues: selectedColumns };
            var preferencedata = { UserId: 0, FunctionId: this.props.functionId, WidgetId: this.props.widgetId, DashboardPreferenceId: this.props.dashboardPreferenceId, RevisionNum: this.props.revisionNum, PreferenceData: JSON.stringify(colsData), CopyToHistory: self.state.copyToHistory }; //WI 26721
            var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(data => {                        
                    this.ShowHideGridColumns(selectedColumns);
                        this.props.closeModelDialog();
                        if(data == "RevisionNum Invalid") {
                            $('#globalLoader').hide();
                            this.props.validateRevisionNum(self.props.dashboardPreferenceId);
                        }
                        else { 
                            var gridPrefData: any = [];
                            this.HideAllGridColumns();
                            this.props.refreshRevisionNum(self.props.dashboardPreferenceId, false);                            
                            this.ShowHideGridColumns(selectedColumns);
                            if (self.props.formname == "ReeferStatusGrid") {
                                GridReeferStatusToolBar.GetColumns(this.props.gridApiParams.gridOptionsWrapper.gridOptions);
                                if(self.state.copyToHistory) {
                                    var copyGridPrefData: any = { SearchData: JSON.stringify(colsData), CopyToHistory: self.state.copyToHistory };                                
                                    gridPrefData.push(copyGridPrefData);
                                    ReeferHistoryGrid.GetReeferHistoryGridPrefColumns(gridPrefData);  //WI 26721
                                 }
                            }
                            else if (self.props.formname == "ReeferGrid" || self.props.formName == "GensetStatus")
                                GridToolBarExcel.GetColumns(this.props.gridApiParams.gridOptionsWrapper.gridOptions);
                            else if (self.props.formname == "ReeferHistoryGrid")
                                GridReeferHistoryToolBar.GetColumns(this.props.gridApiParams.gridOptionsWrapper.gridOptions);
                            else if (self.props.formname == "ReeferHistory" || self.props.formName == "GensetHistory")
                                GridToolBarExcel.GetColumns(this.props.gridApiParams.gridOptionsWrapper.gridOptions);
                            else if (self.props.formname == "GensetHistoryGrid")
                                GridGensetHistoryToolBar.GetColumns(this.props.gridApiParams.gridOptionsWrapper.gridOptions);
                            else if (self.props.formname == "GensetStatusGrid") {  //WI 26721
                                GridGensetStatusToolBar.GetColumns(this.props.gridApiParams.gridOptionsWrapper.gridOptions);
                                if(self.state.copyToHistory) {
                                    var copyGridPrefData: any = { SearchData: JSON.stringify(colsData), CopyToHistory: self.state.copyToHistory };                                
                                    gridPrefData.push(copyGridPrefData);
                                    GensetHistoryGrid.GetGensetHistoryGridPrefColumns(gridPrefData);
                                }
                            }
                            else if (self.props.formname == "DryStatusGrid") { //WI 26721
                                if(self.state.copyToHistory) {
                                    var copyGridPrefData: any = { SearchData: JSON.stringify(colsData), CopyToHistory: self.state.copyToHistory };                                
                                    gridPrefData.push(copyGridPrefData);
                                    DryHistoryGrid.GetDryHistoryGridPrefColumns(gridPrefData);
                                 }
                            }
                            else if (self.props.formname == "ChassisStatusGrid") { //WI 26721
                                if(self.state.copyToHistory) {
                                    var copyGridPrefData: any = { SearchData: JSON.stringify(colsData), CopyToHistory: self.state.copyToHistory };                                
                                    gridPrefData.push(copyGridPrefData);
                                    ChassisHistoryGrid.GetChassisHistoryGridPrefColumns(gridPrefData);
                                }
                            }

                            else if (self.props.formname == "ReeferMapGrid") {   //RCNG-5198
                                ReeferMapGrid.GetReeferMapGridPreferenceColumns();
                            }
                    else if (self.props.formname == "DryStatusGrid")  //WI 26721
                                DryHistoryGrid.GetDryHistoryGridPrefColumns(gridPrefData);
                    else if (self.props.formname == "ChassisStatusGrid")  //WI 26721
                                ChassisHistoryGrid.GetChassisHistoryGridPrefColumns(gridPrefData);
                            $('#globalLoader').hide();
                        }
                    
                });
            
        }
        else
            PopupWindow.showErrorMessage("Alert", "Please select at least one column to save grid preference.");
    }

    closeConfirmation() {
        RCNGWindow.ConfirmWindow.close();
    }

    CancelAction() {
        this.props.closeModelDialog();
    }

    SaveRowGroupsChange = () => {
        this.setState({
            saveRowGroups: !this.state.saveRowGroups,
        });
    }

    onCopyToHistoryCheck(event: React.FormEvent<HTMLInputElement>) {  //WI 26721        
        this.setState({ copyToHistory: event.currentTarget.checked });
    }

    public render() {
        var chkboxCss: any = { 'margin-left': '35px', 'position': 'relative', 'font-size': '15px', 'font-weight': 'bold' };
        var defaultColumns = this.state.exportColumns;
        var dataSource = [];
        if (defaultColumns != undefined && defaultColumns != null && defaultColumns.length > 0) {
            dataSource = defaultColumns.map(function (col) {
                return (
                    { value: col.InterfaceExportColumnId, desc: col.ColumnDisplayNm }
                );
            });
        }

        return <div>
            <div>
                <div className='containerGensetText'>
                    <span className='fields_Show'>Selected Columns / Displayed</span>

                    <span className='fields_hide'>All Columns / Not Displayed</span>
                </div>
                <div className="container">

                    <MultiSelectListBox
                        className={"multi-select"}
                        overrideStrings={{
                            search: "Search...",
                            selectAll: "Add All (>>)",
                            removeAll: "Remove All (<<)",
                            selectedInfo: "Selected Columns / Displayed"
                        }}
                        sortable={true}
                        options={dataSource}
                        textField="desc"
                        valueField="value"
                        value={this.state.selectedKeys}
                        rowHeight={50}
                        onSelect={({ item, sortedList }) => {
                            prefChanged = true;
                            this.setState({ selectedKeys: sortedList.map(i => i.value) });
                        }}
                        onRemove={({ item }) => {
                            prefChanged = true;
                            this.setState({ selectedKeys: [...this.state.selectedKeys.filter(i => i !== item.value)] });
                        }}
                        onSelectAll={selectedItems => {
                            prefChanged = true;
                            const selected = [
                                ...this.state.selectedKeys,
                                ...selectedItems.map(item => item.value)
                            ];
                            this.setState({
                                selectedKeys: selected
                            })
                        }}
                        onRemoveAll={() => {
                            this.setState({
                                selectedKeys: []
                            })
                        }}
                        onSort={({ sortedList }) => {
                            prefChanged = true;
                            this.setState({
                                selectedKeys: [...sortedList.map(i => i.value)]
                            })
                        }}
                        onSearch={(itemsList, textField, query) => {
                            var items: any = itemsList.items;
                            if (items.length > 0 && itemsList.query != "") {
                                var filterlist: any = items.filter(i => i.desc.toUpperCase().includes(itemsList.query.toUpperCase()));
                                return filterlist;
                            }
                            else
                                return items;
                        }}

                    />
                </div>
            </div>


            <div className="modal-footer mt-2 PreferenceSettingsScreen justify-content-between" id="CopyToHistoryFooter">
                <div className="form-check" id='divCopyToHistory'>{/*WI 26721*/}
                    <input type="checkbox" className='form-check-input' name="CopyToHistory" checked={this.state.copyToHistory} onChange={this.onCopyToHistoryCheck.bind(this)} />
                    <span className='form-check-label'>Copy To History</span>
                </div>

                <div className='alert alert-info'> Changes here will update the active dashboard </div>

                <div className='hstack gap-2'>
                    <button type="button" data-bs-dismiss="modal" onClick={this.CancelAction.bind(this)} className="btn btn-secondary" >Cancel</button>
                    <button type="button" onClick={this.ResetGridPreferences.bind(this)} className="btn btn-primary" >Reset</button>
                    <button type="button" className="btn btn-primary" onClick={this.SaveGridPreferences.bind(this)}>Save</button>                 
                   
                </div>
            </div>
        </div>;
    }
}
